module.exports = __webpack_public_path__ + "static/bilxtrahjelpstor4-4b1db2f34d3e221b9daefb6128dab262.png";